import { AddressDto, PatientAddressDto } from '@/lib/ServerApi';

export interface AddressProps {
    address: PatientAddressDto | AddressDto;
}

export function Address({ address }: AddressProps) {
    return address.address + ', ' + address.city + ', ' + address.state + ' ' + (address.zipcode?.slice(0, 5) ?? '');
}
